<template>
  <v-card class="pie_card" style>
    <v-card-title primary class="title white--text">
      <h3 class="headline mb-0">
        <v-icon class="mb-1" color="white">{{icon}}</v-icon>
        {{title}}
      </h3>
    </v-card-title>
    <v-card-text  primary-text style="position: relative;" >
      <v-layout row wrap>
        <v-flex xs8 sm7 md7>
          <canvas
            :id="this.customId"
            style="margin-left: -22px;margin-top: -8px;position:relative;z-index:1;"
            width="200"
            height="150"
          ></canvas>
          
        </v-flex>
        <v-flex xs8 sm5 md5>
          <ul class="menu_pie">
            <li v-for="(pieInfo,i) in pieChart.data.labels" :key="pieInfo">
              <span
                class="circle"
                :style="{backgroundColor: pieChart.data.datasets[0].backgroundColor[i], border: `1px solid ${pieChart.data.datasets[0].borderColor[i]}`}"
              ></span>
              <span :title="pieInfo" class="label">{{pieInfo}}</span>
              <span class="value">{{pieChart.data.datasets[0].data[i]}}</span>
            </li>
          </ul>
        </v-flex>
      </v-layout>
      <h4 v-if="showMsgNoData" style="color: wheat;">
        Sem Dados para <strong>Análise</strong>
      </h4>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: [
    "conta",
    "labels",
    "data",
    "backgroundColor",
    "borderColor",
    "customId",
    "title",
    "icon"
  ],
  data: () => ({
    pieChart: {
      type: "pie",
      data: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: [],
            borderColor: []
          }
        ],
        options: {
          legend: {
            display: false
          },
          elements: {},
          center: {
            text: "90%",
            color: "#FFF", // Default is #000000
            fontStyle: "Arial", // Default is Arial
            sidePadding: 20 // Defualt is 20 (as a percentage)
          }
        },
        display: false
      }
    },
    showMsgNoData: false,
    total: 0
  }),
  watch: {
    data: function(newV,oldV){
      if (newV){
       this.begin();
      }
    },
    backgroundColor: function(newV,oldV){
      if (newV){
       this.begin();
      }
    },
    borderColor: function(newV,oldV){
      if (newV){
       this.begin();
      }
    },
     labels: function(newV,oldV){
      if (newV){
       this.begin();
      }
    } 
  },
  mounted: function() {
    this.$nextTick(function() {
    
    });
  },
  methods: {
    begin: async function(){
      try{
        await this.setData();
        
        if(this.total == 0){
          this.pieChart.data.options.center.text = '';
          this.showMsgNoData = true;
        }else{
          this.pieChart.data.options.center.text = this.total;
          this.showMsgNoData = false;
        }
  
        this.setTextCenterPie();
  
        Chart.defaults.pie.cutoutPercentage = 60;
        Chart.defaults.global.legend.display = false;
        var ctxpie = document.getElementById(this.customId);
        let pieChart = new Chart(ctxpie, this.pieChart);
  
        let totalID = `vlr${this.customId}`;
        // this.animateValue(totalID, 0, 0, 28000, 20);
      }
      catch(err){
        console.log(`Erro ao tentar montar pieChart: \n\n ${err}`)
      }
     
    },
    setTextCenterPie: function() {
      const vlrTotal = this.total;
      if(vlrTotal == 0){
        return ;
      }
      Chart.pluginService.register({
        beforeDraw: function(chart) {
          if (
            chart.config.data.options != undefined &&
            chart.config.data.options.center
          ) {
            //Get ctx from string
            var ctx = chart.chart.ctx;

            //Get options from the center object in options

            var centerConfig = chart.config.data.options.center;
            var fontStyle = centerConfig.fontStyle || "Arial";
            var txt = centerConfig.text;
            var color = centerConfig.color || "#000";
            var sidePadding = centerConfig.sidePadding || 20;
            var sidePaddingCalculated =
              (sidePadding / 100) * (chart.innerRadius * 2);
            //Start with a base font of 30px
            ctx.font = "60px " + fontStyle;

            //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
            var stringWidth = ctx.measureText(txt).width;
            var elementWidth = chart.innerRadius * 2 - sidePaddingCalculated;

            // Find out how much the font can grow in width.
            var widthRatio = elementWidth / stringWidth;
            var newFontSize = Math.floor(30 * widthRatio);
            var elementHeight = chart.innerRadius * 2;

            // Pick a new font size so it will not be larger than the height of label.
            var fontSizeToUse = Math.min(newFontSize, elementHeight);

            //Set font settings to draw it correctly.
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
            var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
            ctx.font = fontSizeToUse + "px " + fontStyle;
            ctx.fillStyle = color;

            //Draw text in center
            ctx.fillText(txt, centerX, centerY);
          }
        }
      });
    },
    animateValue(id, start, end, duration, speed) {
      var range = end - start;
      var current = start;
      var increment = end > start ? speed : 5;
      var stepTime = Math.abs(Math.floor(duration / range));
      var obj = document.getElementById(id);
      var timer = setInterval(function() {
        current += increment;
        obj.innerHTML = current;
        if (current == end || current >= end) {
          clearInterval(timer);
        }
      }, stepTime);
    },
    vlrTotal: function() {
      if (this.data != undefined && this.data.length > 0) {
        let vlr = 0;
        this.data.forEach(valor => {
          vlr += valor;
        });
        this.total = vlr;
      }
    },
    setData: async function() {
      this.showCanvas = true;
      this.pieChart.data.labels = this.labels.slice();
      this.pieChart.data.datasets[0].data = this.data.slice();
      await this.setColors();

      await this.vlrTotal();
    },
    setColors: function() {
      this.setBackgroundColor();
      this.setBorderColor();
    },
    setBackgroundColor: function() {
      if (
        this.backgroundColor != undefined &&
        this.backgroundColor.length > 0
      ) {
        const pieCharBackground = [];
        for (let i = 0; i < this.backgroundColor.length; i++) {
          const cor = this.backgroundColor[i];
          switch (cor.toLocaleLowerCase()) {
            case "red":
              pieCharBackground.push("rgba(255, 0, 0, 0.5)");
              break;
            case "yellow":
              pieCharBackground.push("rgba(247, 255, 0, 0.5)");
              break;
            case "green":
              pieCharBackground.push("rgba(37, 198, 45, 0.5)");
              break;
            case "cyan":
              pieCharBackground.push("rgba(23, 182, 164, 0.5)");
              break;
            case "blue":
              pieCharBackground.push("rgba(54, 162, 235, 0.5)");
              break;
          }
        }
        this.pieChart.data.datasets[0].backgroundColor = pieCharBackground.slice();
      } else {
        this.pieChart.data.datasets[0].backgroundColor = [];
      }
    },
    setBorderColor: function() {
      if (this.borderColor != undefined && this.borderColor.length > 0) {
        const pieChartBorder = [];
        for (let i = 0; i < this.borderColor.length; i++) {
          const cor = this.borderColor[i];
          switch (cor.toLocaleLowerCase()) {
            case "red":
              pieChartBorder.push("rgba(255, 0, 0, 1)");
              break;
            case "yellow":
              pieChartBorder.push("rgba(247, 255, 0, 1)");
              break;
            case "green":
              pieChartBorder.push("rgba(37, 198, 45, 1)");
              break;
            case "cyan":
              pieChartBorder.push("rgba(23, 182, 164, 1)");
              break;
            case "blue":
              pieChartBorder.push("rgba(54, 162, 235, 1)");
              break;
          }
        }
        this.pieChart.data.datasets[0].borderColor = pieChartBorder.slice();
      } else {
        this.pieChart.data.datasets[0].borderColor = [];
      }
    }
  }
};
</script>
<style>
ul.menu_pie {
  list-style-type: none;
  padding: 0;
}
ul.menu_pie li {
  display: inline-block;
  margin: 0 10px;
}
.pie_card {
  min-height: 354px;
  background: #3c454d !important;
  position: relative;
  z-index: 2;
}
.pie_card::before {
  content: "";
  position: absolute;
  background-image: url(/static/img/blur-bg.jpg);
  width: 100%;
  height: 100%;
  background-repeat: initial;
  z-index: -1;
  background-position-x: 19%;
  background-position-y: 191%;
  background-size: inherit;
}
.menu_pie {
  margin-left: -39px;
}
.menu_pie li::after {
  content: "";
  position: absolute;
  width: 65%;
  height: 2px;
  background-color: #7a747440;
  bottom: 7px;
}
.menu_pie li {
  position: relative;
  width: 100%;
  padding-bottom: 5px;
}
.menu_pie .label {
  color: white;
  position: absolute;
  top: 3px;
  left: 2.9em;
  max-width: 60%;
  overflow: hidden;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.menu_pie .circle {
  width: 30px;
  height: 30px;
  display: inherit;
  border-radius: 48%;
  background-color: rgba(54, 162, 235, 0.2);
  box-shadow: 2px 2px 8px 1px #1e1e1e;
  border: 1px solid rgb(54, 162, 235);
}
.menu_pie .value {
  color: white;
  position: absolute;
  top: 3px;
  right: 1em;
}
.descricao_total {
  white-space: pre-line;
  word-wrap: break-word;
  overflow: unset;
  overflow-y: scroll;
  height: 104px;
  text-align: center;
  font-weight: 500;
  /* font-size: 15px; */
  color: white;
}
.valor_total {
  text-align: center;
  color: white;
  font-weight: 800;
}
.card_total {
  position: absolute;
  left: 21%;
  top: 36%;
  z-index: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/loggedArea/dashBoard/charts/chartPie/ChartPie.vue